import { useEffect } from 'react';
import { listenOperationalMapMode } from '../../channels/operationalMapChannel';
import { useOperationalMapStore } from '../../stores/useOperationalMapStore';
import { m } from '../../utils/dateUtils';

export function useOperationalMapModeChannel() {

    useEffect(() => {

        const unsubscribe = listenOperationalMapMode(({ tipo, payload }) => {

            if (tipo === 'operational-map-mode-upsert') {
                 useOperationalMapStore
                    .getState()
                    .setOperationalMapMode(
                        payload,
                        false
                    );
            }

            if (tipo === 'operational-map-mode-range-upsert') {
                 useOperationalMapStore
                    .getState()
                    .setOperationalMapDateRange(
                        m(payload.startDate),
                        m(payload.endDate),
                        false
                    );
            }

            if (tipo === 'operational-map-mode-reset') {
                 useOperationalMapStore
                    .getState()
                    .reset(false);
            }

        });

        return unsubscribe;

    }, []);

}